export default __webpack_public_path__ + "static/community-events-section_hero-mobile-d56091383ba857fcb36465fd83a51676.jpg";